import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types';

const propType = {
    email: PropTypes.string,
    onEmailChange: PropTypes.func,
}

export default class InputEmail extends Component{

    handleChange = (e) =>{
        this.props.onEmailChange(e.target.value);
    }

    render(){
        const { email } = this.props;
        return(
            <Fragment>
                <input className="login-input"
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={email}
                    onChange={ this.handleChange }
                />
                <span className="login-input-focus"></span>
                <span className="login-input-symbol">
                <i className="fa fa-envelope" aria-hidden="true"></i>
                </span>
            </Fragment>
        );
    }

} 

InputEmail.propTypes = propType;



// WEBPACK FOOTER //
// ./src/components/elements/InputEmail/InputEmail.js